/**
 * 샘플 데이터 상수들 (게스트 모드 및 테스트용)
 */

// 게스트 모드 사용자 정보
export const GUEST_USER = {
  id: 'guest-user',
  name: '게스트',
  email: 'guest@example.com',
  avatar: '',
  crew: '체험 크루',
  role: 'MEMBER' as const
};

// 샘플 크루 데이터
export const SAMPLE_CREWS = [
  {
    id: 'crew-1',
    name: '여성1크루',
    description: '은혜롭게 함께하는 여성 크루입니다',
    image: '',
    leader: { id: 'leader-1', name: '김은혜', avatar: '' },
    memberCount: 8,
    maxMembers: 12,
    createdAt: '2024-01-01'
  },
  {
    id: 'crew-2', 
    name: '남성1크루',
    description: '믿음으로 성장하는 남성 크루입니다',
    image: '',
    leader: { id: 'leader-2', name: '박믿음', avatar: '' },
    memberCount: 6,
    maxMembers: 10,
    createdAt: '2024-01-02'
  },
  {
    id: 'crew-3',
    name: '청년크루',
    description: '열정적인 청년들의 크루입니다',
    image: '',
    leader: { id: 'leader-3', name: '이열정', avatar: '' },
    memberCount: 15,
    maxMembers: 20,
    createdAt: '2024-01-03'
  },
  {
    id: 'crew-4',
    name: '가족크루',
    description: '온 가족이 함께하는 크루입니다',
    image: '',
    leader: { id: 'leader-4', name: '최가족', avatar: '' },
    memberCount: 12,
    maxMembers: 15,
    createdAt: '2024-01-04'
  },
  {
    id: 'crew-5',
    name: '새신자크루',
    description: '새롭게 시작하는 분들을 위한 크루입니다',
    image: '',
    leader: { id: 'leader-5', name: '김새로', avatar: '' },
    memberCount: 4,
    maxMembers: 8,
    createdAt: '2024-01-05'
  }
];

// 샘플 크루 멤버 데이터
export const SAMPLE_CREW_MEMBERS = [
  { id: 'member-1', name: '김은혜', avatar: '', hasSharedToday: false },
  { id: 'member-2', name: '이평안', avatar: '', hasSharedToday: true },
  { id: 'member-3', name: '박기쁨', avatar: '', hasSharedToday: true },
  { id: 'member-4', name: '최사랑', avatar: '', hasSharedToday: false },
  { id: 'member-5', name: '정소망', avatar: '', hasSharedToday: true }
];

// 샘플 멤버 묵상 데이터
export const SAMPLE_MEMBER_MEDITATIONS = {
  'member-2': {
    id: 'med-1',
    user: { id: 'member-2', name: '이평안', avatar: '', church: '샘플교회' },
    date: '2024-01-01',
    verseReference: '시편 23장 1절',
    verseText: '여호와는 나의 목자시니 내게 부족함이 없으리로다',
    readingCount: 100,
    godsWill: '하나님께서 나의 모든 필요를 채워주신다는 것을 깨달았습니다.',
    growthChange: '더 많은 감사와 신뢰의 마음을 가져야겠습니다.',
    prayer: '주님, 항상 저와 함께 해주셔서 감사합니다.',
    prayerShareType: 'public' as const,
    createdAt: '2024-01-01'
  },
  'member-3': {
    id: 'med-2',
    user: { id: 'member-3', name: '박기쁨', avatar: '', church: '샘플교회' },
    date: '2024-01-01',
    verseReference: '빌립보서 4장 13절',
    verseText: '내게 능력 주시는 자 안에서 내가 모든 것을 할 수 있느니라',
    readingCount: 100,
    godsWill: '하나님의 능력으로 모든 어려움을 극복할 수 있음을 배웠습니다.',
    growthChange: '두려움 대신 담대함을 가져야겠습니다.',
    prayer: '주님의 능력으로 오늘 하루도 승리하게 하소서.',
    prayerShareType: 'request' as const,
    createdAt: '2024-01-01'
  },
  'member-5': {
    id: 'med-3',
    user: { id: 'member-5', name: '정소망', avatar: '', church: '샘플교회' },
    date: '2024-01-01',
    verseReference: '로마서 8장 28절',
    verseText: '우리가 알거니와 하나님을 사랑하는 자 곧 그의 뜻대로 부르심을 입은 자들에게는 모든 것이 합력하여 선을 이루느니라',
    readingCount: 100,
    godsWill: '모든 상황에서 하나님의 선한 계획이 있음을 믿어야 합니다.',
    growthChange: '어려운 상황에서도 하나님을 더욱 의지해야겠습니다.',
    prayer: '주님, 모든 것을 합력하여 선을 이루시는 주님을 찬양합니다.',
    prayerShareType: 'public' as const,
    createdAt: '2024-01-01'
  }
};

// 샘플 피드 데이터
export const SAMPLE_FEED_DATA = [
  {
    id: 'feed-1',
    user: { id: 'user-1', name: '김은혜', avatar: '', crew: '여성1크루' },
    date: '2024-01-01',
    verseReference: '시편 23장 1절',
    verseText: '여호와는 나의 목자시니 내게 부족함이 없으리로다',
    time: '30분',
    content: '오늘 하루도 주님과 함께 걸어가겠습니다.',
    likes: 12,
    comments: 3,
    prayerShareType: 'public' as const,
    createdAt: '2024-01-01T09:00:00Z'
  },
  {
    id: 'feed-2',
    user: { id: 'user-2', name: '이평안', avatar: '', crew: '남성1크루' },
    date: '2024-01-01',
    verseReference: '빌립보서 4장 13절',
    verseText: '내게 능력 주시는 자 안에서 내가 모든 것을 할 수 있느니라',
    time: '25분',
    content: '하나님의 능력으로 모든 것을 할 수 있다는 확신을 얻었습니다.',
    likes: 8,
    comments: 2,
    prayerShareType: 'request' as const,
    createdAt: '2024-01-01T08:30:00Z'
  },
  {
    id: 'feed-3',
    user: { id: 'user-3', name: '박기쁨', avatar: '', crew: '청년크루' },
    date: '2024-01-01',
    verseReference: '로마서 8장 28절',
    verseText: '우리가 알거니와 하나님을 사랑하는 자 곧 그의 뜻대로 부르심을 입은 자들에게는 모든 것이 합력하여 선을 이루느니라',
    time: '35분',
    content: '어려운 상황에서도 하나님의 선한 계획을 믿습니다.',
    likes: 15,
    comments: 5,
    prayerShareType: 'public' as const,
    createdAt: '2024-01-01T08:00:00Z'
  },
  {
    id: 'feed-4',
    user: { id: 'user-4', name: '최사랑', avatar: '', crew: '가족크루' },
    date: '2024-01-01',
    verseReference: '요한복음 3장 16절',
    verseText: '하나님이 세상을 이처럼 사랑하사 독생자를 주셨으니 이는 그를 믿는 자마다 멸망하지 않고 영생을 얻게 하려 하심이라',
    time: '40분',
    content: '하나님의 사랑을 다시 한번 깨달았습니다.',
    likes: 20,
    comments: 7,
    prayerShareType: 'public' as const,
    createdAt: '2024-01-01T07:30:00Z'
  },
  {
    id: 'feed-5',
    user: { id: 'user-5', name: '정소망', avatar: '', crew: '새신자크루' },
    date: '2024-01-01',
    verseReference: '마태복음 11장 28절',
    verseText: '수고하고 무거운 짐 진 자들아 다 내게로 오라 내가 너희를 쉬게 하리라',
    time: '20분',
    content: '주님께서 주시는 참된 안식을 경험했습니다.',
    likes: 6,
    comments: 1,
    prayerShareType: 'request' as const,
    createdAt: '2024-01-01T07:00:00Z'
  }
];

// 오늘의 말씀 (기본값)
export const DEFAULT_VERSE = {
  reference: '요한복음 3장 16절',
  text: '하나님이 세상을 이처럼 사랑하사 독생자를 주셨으니 이는 그를 믿는 자마다 멸망하지 않고 영생을 얻게 하려 하심이라'
};

// 신급 옵션들
export const POSITION_OPTIONS = [
  '새신자',
  '성도', 
  '집사',
  '권사',
  '안수집사',
  '장로',
  '목사',
  '전도사',
  '기타'
] as const;
